<template>
  <div>
    <div class="cont-header d-flex flex-row justify-center align-center">
      <div class="duda">¿Dudas?</div>
      <div class="ml-2 contacto">Contáctanos</div>
    </div>

    <div class="cont-header d-flex flex-row justify-center align-center">
      <div>
        <v-btn
          class="align-self-center btn-customisado1"
          v-bind="attrs"
          v-on="on"
          elevation="3"
          @click="whats"
        >
          M
          <div class="mastext">ensaje</div>
          <v-icon right light>mdi-whatsapp</v-icon></v-btn
        >
      </div>
      <div>
        <v-btn
          class="align-self-center btn-customisado2"
          v-bind="attrs"
          v-on="on"
          elevation="3"
          @click="llamar"
          >L
          <div class="mastext">lamar</div>
          <v-icon right light>mdi-phone</v-icon></v-btn
        >
      </div>
    </div>

    <div class="infodatos d-flex flex-row justify-center align-center mt-6">
      Tus datos están protegidos por nuestro
    </div>
    <div class="btn-priv d-flex flex-row justify-center align-center">
      Aviso de Privacidad
    </div>

    <div class="d-flex flex-row justify-center align-center mt-6 mb-4">
      <div class="text1">#EL</div>
      <div class="text2">RESPALDO</div>
      <div class="text1">QUE</div>
      <div class="text2">NECESITAS</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data: () => ({
    //
  }),
  computed: {
    ObtenerLogo() {
      return require('@/assets/images/logo_solo_blanco.png')
    },
  },
  methods: {
    whats() {
      window.open('https://wa.me/5215510695948', '_blank')
    },
    llamar() {
      window.open('tel:8003000268', '_blank')
    },
  },
  props: {
    icono: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped lang="scss">
.cont-header {
  background-color: white;
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
  font-family: 'Poppins', sans-serif;
  font-weight: 900 !important;
}
.infodatos {
  font-family: 'Poppins', sans-serif;
}
.duda {
  color: black;
  font-size: 18px;
  font-weight: bold;
}
.contacto {
  color: #045818;
  font-size: 18px;
  font-weight: bold;
}
.btn-customisado1 {
  margin: 20px;
  border-radius: 20px;
  margin-bottom: 5px;
  border: 1px solid black !important;
  width: 150px;
}

.mastext {
  text-transform: lowercase !important;
}

.btn-customisado2 {
  margin: 20px;
  border-radius: 20px;
  margin-bottom: 5px;
  background-color: black !important;
  color: white !important;
  padding: 20px !important;
  width: 150px;
  text-transform: uppercase !important;
}
.btn-priv {
  color: black;
  font-family: 'Poppins', sans-serif !important;
  font-weight: 900 !important;
}
.text1 {
  font-family: 'Poppins', sans-serif !important;
  font-weight: 900 !important;
  font-size: 16px;
  font-weight: 900;
  line-height: 18px;
  letter-spacing: -0.07999999821186066px;
  text-align: left;
}
.text2 {
  color: #84bd00;
  font-size: 16px;
  font-family: 'Poppins', sans-serif !important;
  font-weight: 900 !important;
}
</style>
